var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// server/utils/thermostatConstants.js
var require_thermostatConstants = __commonJS({
  "server/utils/thermostatConstants.js"(exports, module) {
    var DEFAULT_PRESET_TEMPS = {
      frost: 7,
      away: 16,
      eco: 18,
      night: 17,
      comfort: 21
    };
    var FALLBACK_SETPOINT = 20;
    var DEFAULT_HYSTERESIS_START = 0.5;
    var DEFAULT_HYSTERESIS_STOP = 0.5;
    var DEFAULT_TPI_CYCLE_TIME = 30;
    var DEFAULT_TPI_PROPORTIONAL_BAND = 2;
    var MIN_TPI_CYCLE_TIME = 5;
    var MAX_TPI_CYCLE_TIME = 120;
    var MIN_TPI_PROPORTIONAL_BAND = 0.5;
    var MAX_TPI_PROPORTIONAL_BAND = 10;
    var DEFAULT_MODE = "heating";
    var DEFAULT_CONTROL_TYPE = "hysteresis";
    var DEFAULT_MIN_TEMP = 5;
    var DEFAULT_MAX_TEMP = 35;
    var DEFAULT_TEMP_UNIT = "C";
    var DEFAULT_MANUAL_DURATION_MINUTES = 30;
    var MANUAL_DURATION_MS = DEFAULT_MANUAL_DURATION_MINUTES * 60 * 1e3;
    var PRESETS = ["frost", "away", "eco", "night", "comfort"];
    var TRANSITION_PRESETS = [...PRESETS, "off"];
    var THERMOSTAT_TYPES = {
      VIRTUAL: "virtual",
      EXTERNAL: "external"
    };
    var DEFAULT_THERMOSTAT_TYPE = THERMOSTAT_TYPES.VIRTUAL;
    module.exports = {
      DEFAULT_PRESET_TEMPS,
      FALLBACK_SETPOINT,
      DEFAULT_HYSTERESIS_START,
      DEFAULT_HYSTERESIS_STOP,
      DEFAULT_TPI_CYCLE_TIME,
      DEFAULT_TPI_PROPORTIONAL_BAND,
      MIN_TPI_CYCLE_TIME,
      MAX_TPI_CYCLE_TIME,
      MIN_TPI_PROPORTIONAL_BAND,
      MAX_TPI_PROPORTIONAL_BAND,
      DEFAULT_MODE,
      DEFAULT_CONTROL_TYPE,
      DEFAULT_MIN_TEMP,
      DEFAULT_MAX_TEMP,
      DEFAULT_TEMP_UNIT,
      DEFAULT_MANUAL_DURATION_MINUTES,
      MANUAL_DURATION_MS,
      PRESETS,
      TRANSITION_PRESETS,
      THERMOSTAT_TYPES,
      DEFAULT_THERMOSTAT_TYPE
    };
  }
});
const __cjsModule = require_thermostatConstants();
export default __cjsModule;
export const DEFAULT_PRESET_TEMPS = __cjsModule.DEFAULT_PRESET_TEMPS;
export const FALLBACK_SETPOINT = __cjsModule.FALLBACK_SETPOINT;
export const DEFAULT_HYSTERESIS_START = __cjsModule.DEFAULT_HYSTERESIS_START;
export const DEFAULT_HYSTERESIS_STOP = __cjsModule.DEFAULT_HYSTERESIS_STOP;
export const DEFAULT_TPI_CYCLE_TIME = __cjsModule.DEFAULT_TPI_CYCLE_TIME;
export const DEFAULT_TPI_PROPORTIONAL_BAND = __cjsModule.DEFAULT_TPI_PROPORTIONAL_BAND;
export const MIN_TPI_CYCLE_TIME = __cjsModule.MIN_TPI_CYCLE_TIME;
export const MAX_TPI_CYCLE_TIME = __cjsModule.MAX_TPI_CYCLE_TIME;
export const MIN_TPI_PROPORTIONAL_BAND = __cjsModule.MIN_TPI_PROPORTIONAL_BAND;
export const MAX_TPI_PROPORTIONAL_BAND = __cjsModule.MAX_TPI_PROPORTIONAL_BAND;
export const DEFAULT_MODE = __cjsModule.DEFAULT_MODE;
export const DEFAULT_CONTROL_TYPE = __cjsModule.DEFAULT_CONTROL_TYPE;
export const DEFAULT_MIN_TEMP = __cjsModule.DEFAULT_MIN_TEMP;
export const DEFAULT_MAX_TEMP = __cjsModule.DEFAULT_MAX_TEMP;
export const DEFAULT_TEMP_UNIT = __cjsModule.DEFAULT_TEMP_UNIT;
export const DEFAULT_MANUAL_DURATION_MINUTES = __cjsModule.DEFAULT_MANUAL_DURATION_MINUTES;
export const MANUAL_DURATION_MS = __cjsModule.MANUAL_DURATION_MS;
export const PRESETS = __cjsModule.PRESETS;
export const TRANSITION_PRESETS = __cjsModule.TRANSITION_PRESETS;
export const THERMOSTAT_TYPES = __cjsModule.THERMOSTAT_TYPES;
export const DEFAULT_THERMOSTAT_TYPE = __cjsModule.DEFAULT_THERMOSTAT_TYPE;
